import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'
import { Dispatch, SetStateAction } from 'react'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { PLANNING_BY_FY_FQ, PLANNING_SUBSCRIPTION_CATEGORY } from '../config'
import { IFieldProps } from '../models/IFieldProps'

import { getFieldName } from './getFieldName'
import { setItemValuesUniversal } from './setItemValuesUniversal'

interface IProps {
  items: IJBPPlanningItem[]
  setting: IFormActualsTargetsSettings
  fieldProps: IFieldProps
  fy: number
  setTargetsItems: Dispatch<SetStateAction<IJBPPlanningItem[]>>
  translationFactors?: ITranslationFactors[] | null
}

export const setFYTotalByQuarters = ({
  items,
  setting,
  fieldProps,
  fy,
  setTargetsItems,
  translationFactors,
}: IProps) => {
  const data = [...items]

  const fieldName = getFieldName(fieldProps)
  const cat = setting.Category

  // Filtered on Top level: PartnerId, ProgramTypes, Category, IsActuals, IsTarget, IsQuota
  const fyData = items.filter(
    (el) =>
      el.ProgramTypes === setting.ProgramType &&
      el.Category === setting.Category &&
      el.SubCategory === setting.SubCategory &&
      el.L3Category === setting.L3Category &&
      el.FYear === fy &&
      el.FQuarter === PLANNING_BY_FY_FQ
  )

  if (fyData.length >= 1) {
    // Calc Total or get Last FQ Value
    let lastFqValue = 0
    let lastNotEmptyFqValue: number | null = null
    let total: number | null = null
    for (let fq = 1; fq < PLANNING_BY_FY_FQ; fq++) {
      const qData = items.filter(
        (el) =>
          el.ProgramTypes === setting.ProgramType &&
          el.Category === setting.Category &&
          el.SubCategory === setting.SubCategory &&
          el.L3Category === setting.L3Category &&
          el.FYear === fy &&
          el.FQuarter === fq
      )
      if (qData.length >= 1) {
        const originalValue = qData[0][fieldName]
        if (originalValue || originalValue === 0) {
          lastFqValue = Number(originalValue ?? 0)
          total = (total ?? 0) + lastFqValue
          lastNotEmptyFqValue = lastFqValue
        }
      }
    }

    const isSubscription = cat === PLANNING_SUBSCRIPTION_CATEGORY && fieldProps.isUnits
    const newValue = isSubscription ? lastNotEmptyFqValue : total

    // Set New Value
    const newItem = setItemValuesUniversal(
      fyData[0],
      newValue,
      fieldProps,
      cat,
      false,
      translationFactors
    )

    const idx = items.indexOf(fyData[0])
    data.splice(idx, 1, newItem)

    setTargetsItems([...data])
  }

  return data
}
